/*
 * Tua História — configurador de almofadas personalizadas.
 * Usado pela secção "configurador-almofada" do tema e pelo protótipo local.
 *
 * Cada configurador é um elemento [data-th-almofada] com um
 * <script type="application/json"> lá dentro (ver a secção Liquid).
 */

const PADRAO = {
  servidor: 'http://localhost:8000',
  modulo3d: './almofada-3d.js',
  lingua: 'pt',                  // pt | es | de (vem de request.locale na secção)
  maxMb: 15,
  margemCm: 1.5,
  diasProducao: 0,              // 0 = não mostra o prazo
  depoisDeAdicionar: 'carrinho', // carrinho | gaveta | ficar
  modoTeste: false,
  tamanhos: [],                  // [{ etiqueta, cm, varianteId, preco, disponivel, padrao }]
  textos: {},                    // textos alterados no editor de temas (só os preenchidos)
};

// Textos por língua. Os campos preenchidos no editor de temas sobrepõem-se a estes.
const TEXTOS = {
  pt: {
    titulo: 'Cria a tua almofada',
    subtitulo: 'Carrega uma foto e vê a tua almofada em 3D, com a forma de quem mais gostas.',
    uploadAjuda: 'JPG, PNG ou HEIC · até 15 MB',
    uploadBotao: 'Carrega a tua foto',
    uploadArrastar: 'ou arrasta-a para aqui',
    dica: 'Dica: escolhe uma foto nítida, com boa luz e com a pessoa ou o animal inteiro na imagem.',
    privacidade: 'A tua foto é usada só para criar a almofada e é apagada se não fizeres a encomenda ou assim que a receberes.',
    privacidadeLink: 'Política de privacidade',
    aGerarTitulo: 'A preparar a tua almofada…',
    aGerarMensagens: 'A recortar a tua foto|A desenhar a forma da almofada|A acrescentar a margem branca|A encher de fofura|Quase pronta',
    aGerarAjuda: 'Isto pode demorar até 30 segundos.',
    arrastar: 'Arrasta para rodar',
    medidas: 'Medidas aproximadas: {largura} × {altura} cm',
    tamanhoTitulo: 'Escolhe o tamanho',
    mudarImagem: 'Mudar imagem',
    adicionar: 'Adicionar ao carrinho',
    aAdicionar: 'A adicionar…',
    adicionado: 'Adicionado ao carrinho ✓',
    criarOutra: 'Criar outra almofada',
    descontoOutra: 'Junta a 2.ª e poupas 10% em cada',
    desconto3: 'Junta a 3.ª e poupas 15% em cada',
    desconto4: 'Junta a 4.ª e poupas 25% em cada',
    verCarrinho: 'Ver carrinho',
    semImagem: 'Carrega uma foto para continuar',
    esgotado: 'Esgotado',
    aviso: 'A pré-visualização 3D é ilustrativa. A nossa equipa revê cada foto antes de produzir a tua almofada.',
    prazo: 'Feita por encomenda · enviada entre 3 a 4 dias',
    prazoLink: 'Política de envio',
    personalizado: 'Por ser um produto personalizado, feito à tua medida, não está abrangido pelo direito de livre resolução de 14 dias.',
    erroTipo: 'Este ficheiro não é uma imagem. Usa uma foto JPG, PNG ou HEIC.',
    erroTamanho: 'A foto é maior do que {mb} MB. Escolhe uma foto mais leve.',
    erroGeral: 'Não conseguimos preparar a tua foto. Verifica a ligação e tenta de novo.',
    erroCarrinho: 'Não foi possível adicionar ao carrinho. Tenta de novo.',
    erroFormato: 'Formato não suportado. Usa uma foto JPG, PNG ou HEIC.',
    erroIlegivel: 'Não conseguimos ler esta imagem. Tenta outra foto (JPG, PNG ou HEIC).',
    erroPequena: 'A imagem é demasiado pequena. Usa uma foto com pelo menos 200 píxeis.',
    erroSemMotivo: 'Não encontrámos ninguém nesta foto. Experimenta uma foto com a pessoa ou o animal bem visível.',
    erroMotivoPequeno: 'A pessoa ou o animal aparece muito pequeno. Experimenta uma foto mais próxima.',
    erroLimite: 'Fizeste muitos pedidos seguidos. Tenta de novo daqui a pouco.',
    erroOcupado: 'Estamos com muitos pedidos neste momento. Tenta de novo dentro de um minuto.',
    tentarNovamente: 'Tentar de novo',
    suasAlmofadas: 'As tuas almofadas', umaPorFoto: 'Cada uma pode ter a sua foto', almofadaN: 'Almofada {n}',
    adicionarAlmofada: '+ Adicionar almofada', editar: 'Editar', rotTamanho: 'Tamanho', rotFoto: 'Foto',
    adicionarFoto: 'Adicionar foto', poupaUm: 'poupa {v}', poupaMais: 'poupa mais {v}', poupasValor: 'Poupas {v}', semFotoCurta: 'Sem foto', semFotoAinda: 'Ainda sem foto', mudarFoto: 'Mudar foto', aPrepararCurto: 'A preparar…',
    comErro: 'Foto com problema', adicionarTotal: 'Adicionar ao carrinho · {total}', remover: 'Remover',
    poupas: 'Poupas {pct}% em cada almofada', faltaFoto: 'Falta a foto da {nome}', aindaAPreparar: 'A preparar as almofadas…',
  },
  es: {
    titulo: 'Crea tu cojín',
    subtitulo: 'Sube una foto y mira tu cojín en 3D, con la forma de quien más quieres.',
    uploadAjuda: 'JPG, PNG o HEIC · hasta 15 MB',
    uploadBotao: 'Sube tu foto',
    uploadArrastar: 'o arrástrala aquí',
    dica: 'Consejo: elige una foto nítida, con buena luz y con la persona o el animal entero en la imagen.',
    privacidade: 'Tu foto se usa solo para crear el cojín y se elimina si no haces el pedido o en cuanto lo recibas.',
    privacidadeLink: 'Política de privacidad',
    aGerarTitulo: 'Preparando tu cojín…',
    aGerarMensagens: 'Recortando tu foto|Dibujando la forma del cojín|Añadiendo el borde blanco|Rellenándolo bien|Casi listo',
    aGerarAjuda: 'Esto puede tardar hasta 30 segundos.',
    arrastar: 'Arrastra para girar',
    medidas: 'Medidas aproximadas: {largura} × {altura} cm',
    tamanhoTitulo: 'Elige el tamaño',
    mudarImagem: 'Cambiar imagen',
    adicionar: 'Añadir al carrito',
    aAdicionar: 'Añadiendo…',
    adicionado: 'Añadido al carrito ✓',
    criarOutra: 'Crear otro cojín',
    descontoOutra: 'Añade el 2.º y ahorras un 10% en cada uno',
    desconto3: 'Añade el 3.º y ahorras un 15% en cada uno',
    desconto4: 'Añade el 4.º y ahorras un 25% en cada uno',
    verCarrinho: 'Ver carrito',
    semImagem: 'Sube una foto para continuar',
    esgotado: 'Agotado',
    aviso: 'La vista previa en 3D es orientativa. Nuestro equipo revisa cada foto antes de fabricar tu cojín.',
    prazo: 'Hecho por encargo · se envía en 3 a 4 días',
    prazoLink: 'Política de envío',
    personalizado: 'Al ser un producto personalizado, hecho a tu medida, no está sujeto al derecho de desistimiento de 14 días.',
    erroTipo: 'Este archivo no es una imagen. Usa una foto JPG, PNG o HEIC.',
    erroTamanho: 'La foto pesa más de {mb} MB. Elige una foto más ligera.',
    erroGeral: 'No hemos podido preparar tu foto. Comprueba la conexión e inténtalo de nuevo.',
    erroCarrinho: 'No se ha podido añadir al carrito. Inténtalo de nuevo.',
    erroFormato: 'Formato no compatible. Usa una foto JPG, PNG o HEIC.',
    erroIlegivel: 'No hemos podido leer esta imagen. Prueba con otra foto (JPG, PNG o HEIC).',
    erroPequena: 'La imagen es demasiado pequeña. Usa una foto de al menos 200 píxeles.',
    erroSemMotivo: 'No hemos encontrado a nadie en esta foto. Prueba con una foto en la que la persona o el animal se vea bien.',
    erroMotivoPequeno: 'La persona o el animal sale muy pequeño. Prueba con una foto más cercana.',
    erroLimite: 'Has hecho muchas solicitudes seguidas. Inténtalo de nuevo dentro de un rato.',
    erroOcupado: 'Ahora mismo tenemos muchas solicitudes. Inténtalo de nuevo en un minuto.',
    tentarNovamente: 'Intentar de nuevo',
    suasAlmofadas: 'Tus cojines', umaPorFoto: 'Cada uno puede tener su foto', almofadaN: 'Cojín {n}',
    adicionarAlmofada: '+ Añadir cojín', editar: 'Editar', rotTamanho: 'Tamaño', rotFoto: 'Foto',
    adicionarFoto: 'Añadir foto', poupaUm: 'ahorra {v}', poupaMais: 'ahorra {v} más', poupasValor: 'Ahorras {v}', semFotoCurta: 'Sin foto', semFotoAinda: 'Aún sin foto', mudarFoto: 'Cambiar foto', aPrepararCurto: 'Preparando…',
    comErro: 'Problema con la foto', adicionarTotal: 'Añadir al carrito · {total}', remover: 'Quitar',
    poupas: 'Ahorras un {pct}% en cada cojín', faltaFoto: 'Falta la foto del {nome}', aindaAPreparar: 'Preparando los cojines…',
  },
  de: {
    titulo: 'Gestalte dein Kissen',
    subtitulo: 'Lade ein Foto hoch und sieh dein Kissen in 3D – in der Form deiner Liebsten.',
    uploadAjuda: 'JPG, PNG oder HEIC · bis 15 MB',
    uploadBotao: 'Lade dein Foto hoch',
    uploadArrastar: 'oder hierher ziehen',
    dica: 'Tipp: Wähle ein scharfes, gut beleuchtetes Foto, auf dem die Person oder das Tier vollständig zu sehen ist.',
    privacidade: 'Dein Foto wird nur für dein Kissen verwendet und gelöscht, wenn du nicht bestellst oder sobald du es erhalten hast.',
    privacidadeLink: 'Datenschutzerklärung',
    aGerarTitulo: 'Dein Kissen wird vorbereitet …',
    aGerarMensagens: 'Foto wird freigestellt|Kissenform wird gezeichnet|Weißer Rand wird hinzugefügt|Kissen wird aufgeplustert|Fast fertig',
    aGerarAjuda: 'Das kann bis zu 30 Sekunden dauern.',
    arrastar: 'Zum Drehen ziehen',
    medidas: 'Ungefähre Maße: {largura} × {altura} cm',
    tamanhoTitulo: 'Wähle die Größe',
    mudarImagem: 'Bild ändern',
    adicionar: 'In den Warenkorb',
    aAdicionar: 'Wird hinzugefügt …',
    adicionado: 'In den Warenkorb gelegt ✓',
    criarOutra: 'Weiteres Kissen gestalten',
    descontoOutra: 'Mit dem 2. Kissen sparst du 10 % auf jedes',
    desconto3: 'Mit dem 3. Kissen sparst du 15 % auf jedes',
    desconto4: 'Mit dem 4. Kissen sparst du 25 % auf jedes',
    verCarrinho: 'Zum Warenkorb',
    semImagem: 'Lade ein Foto hoch, um fortzufahren',
    esgotado: 'Ausverkauft',
    aviso: 'Die 3D-Vorschau dient zur Orientierung. Unser Team prüft jedes Foto, bevor dein Kissen hergestellt wird.',
    prazo: 'Auf Bestellung gefertigt · Versand in 3 bis 4 Tagen',
    prazoLink: 'Versandbedingungen',
    personalizado: 'Da es sich um ein personalisiertes, nach deinen Vorgaben gefertigtes Produkt handelt, besteht kein 14-tägiges Widerrufsrecht.',
    erroTipo: 'Diese Datei ist kein Bild. Bitte verwende ein Foto im Format JPG, PNG oder HEIC.',
    erroTamanho: 'Das Foto ist größer als {mb} MB. Bitte wähle ein kleineres Foto.',
    erroGeral: 'Wir konnten dein Foto nicht vorbereiten. Prüfe deine Verbindung und versuche es erneut.',
    erroCarrinho: 'Das Kissen konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.',
    erroFormato: 'Dieses Format wird nicht unterstützt. Bitte verwende JPG, PNG oder HEIC.',
    erroIlegivel: 'Wir konnten dieses Bild nicht lesen. Versuche es mit einem anderen Foto (JPG, PNG oder HEIC).',
    erroPequena: 'Das Bild ist zu klein. Bitte verwende ein Foto mit mindestens 200 Pixeln.',
    erroSemMotivo: 'Auf diesem Foto konnten wir niemanden erkennen. Versuche ein Foto, auf dem die Person oder das Tier gut zu sehen ist.',
    erroMotivoPequeno: 'Die Person oder das Tier ist sehr klein. Versuche ein Foto aus kürzerer Entfernung.',
    erroLimite: 'Du hast viele Anfragen hintereinander gesendet. Bitte versuche es gleich noch einmal.',
    erroOcupado: 'Gerade gibt es sehr viele Anfragen. Bitte versuche es in einer Minute erneut.',
    tentarNovamente: 'Erneut versuchen',
    suasAlmofadas: 'Deine Kissen', umaPorFoto: 'Jedes kann ein eigenes Foto haben', almofadaN: 'Kissen {n}',
    adicionarAlmofada: '+ Kissen hinzufügen', editar: 'Bearbeiten', rotTamanho: 'Größe', rotFoto: 'Foto',
    adicionarFoto: 'Foto hinzufügen', poupaUm: '{v} sparen', poupaMais: '{v} mehr sparen', poupasValor: 'Du sparst {v}', semFotoCurta: 'Ohne Foto', semFotoAinda: 'Noch kein Foto', mudarFoto: 'Foto ändern', aPrepararCurto: 'Wird vorbereitet …',
    comErro: 'Problem mit dem Foto', adicionarTotal: 'In den Warenkorb · {total}', remover: 'Entfernen',
    poupas: 'Du sparst {pct} % auf jedes Kissen', faltaFoto: 'Für {nome} fehlt noch ein Foto', aindaAPreparar: 'Kissen werden vorbereitet …',
  },
};

// código de erro do servidor → texto
const ERROS_SERVIDOR = {
  formato: 'erroFormato', ilegivel: 'erroIlegivel', pequena: 'erroPequena', grande: 'erroTamanho',
  sem_motivo: 'erroSemMotivo', motivo_pequeno: 'erroMotivoPequeno', limite: 'erroLimite',
  ocupado: 'erroOcupado', geral: 'erroGeral',
};

export function textosPara(lingua) {
  const base = String(lingua || 'pt').toLowerCase().slice(0, 2);
  return TEXTOS[base] || TEXTOS.pt;
}

function h(tag, atributos = {}, ...filhos) {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(atributos)) {
    if (v === false || v == null) continue;
    if (k === 'class') el.className = v;
    else if (k.startsWith('on')) el.addEventListener(k.slice(2), v);
    else el.setAttribute(k, v === true ? '' : v);
  }
  for (const f of filhos.flat()) if (f != null && f !== false) el.append(f);
  return el;
}

const ICONES = {
  foto: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="15" rx="3"/><circle cx="12" cy="12.5" r="3.5"/><path d="M8 5l1.5-2h5L16 5"/></svg>',
  trocar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12a8 8 0 0113.7-5.6L20 8.7"/><path d="M20 4v4.7h-4.7"/><path d="M20 12a8 8 0 01-13.7 5.6L4 15.3"/><path d="M4 20v-4.7h4.7"/></svg>',
  camiao: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6h12v10H2z"/><path d="M14 9h4l4 4v3h-8"/><circle cx="6.5" cy="17.5" r="1.5"/><circle cx="17.5" cy="17.5" r="1.5"/></svg>',
  escudo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.4-3 8.3-7 10-4-1.7-7-5.6-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>',
  rodar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12c0-2.2 4-4 9-4s9 1.8 9 4-4 4-9 4"/><path d="M14.5 13.5L12 16l2.5 2.5"/></svg>',
};

// silhuetas brancas (PNG) das almofadas que rodam em 3D enquanto o recorte é preparado; ficam na pasta do almofada-3d.js
const FORMAS = ['cao'];

function icone(nome) {
  const s = h('span', { class: 'th-alm__icone', 'aria-hidden': 'true' });
  s.innerHTML = ICONES[nome];
  return s;
}

function formatar(texto, valores) {
  return texto.replace(/\{(\w+)\}/g, (_, k) => (k in valores ? valores[k] : `{${k}}`));
}

export function iniciar(raiz, cfgParcial) {
  if (raiz._thAlmofada) raiz._thAlmofada.destruir();
  const cfg = { ...PADRAO, ...cfgParcial };
  const T = { ...TEXTOS.pt, ...textosPara(cfg.lingua),
    ...Object.fromEntries(Object.entries(cfg.textos || {}).filter(([, v]) => v && String(v).trim())) };

  const tamanhoPadrao = cfg.tamanhos.find((t) => t.padrao && t.disponivel) || cfg.tamanhos.find((t) => t.disponivel)
    || cfg.tamanhos[0] || { cm: 40, disponivel: false };
  // várias almofadas antes de ir para o carrinho (como nas sweats): cada uma tem a sua foto e o seu tamanho
  const novaAlmofada = (tamanho = tamanhoPadrao) => ({
    fase: 'vazio',            // vazio | a-gerar | pronta | erro
    resultado: null,          // resposta do servidor (recorte)
    tamanho, medidas: null, nomeFicheiro: '', erro: '', inicio: 0, pedido: null,
    noCarrinho: false,        // já foi adicionada (não volta a ir, a não ser que mude)
  });
  // as que ainda não foram para o carrinho
  const pendentes = () => estado.almofadas.filter((a) => !a.noCarrinho);
  const alterada = (a) => { a.noCarrinho = false; estado.adicionado = false; };
  const estado = {
    fase: 'vazio',            // fase do palco (a almofada que se está a ver): vazio | a-gerar | preview | erro
    almofadas: [novaAlmofada()],
    ativa: 0,
    ocupado: false,           // a adicionar ao carrinho: a lista fica bloqueada até acabar
    visor: null,
    vista: 0,
  };
  const atual = () => estado.almofadas[estado.ativa];
  const nomeDe = (a) => formatar(T.almofadaN, { n: estado.almofadas.indexOf(a) + 1 });

  let modulo3d = null;
  const carregar3d = () => (modulo3d ||= import(cfg.modulo3d));
  // o motor 3D e a forma da animação de espera começam a descarregar logo, enquanto o cliente escolhe a foto
  const preCarregar = () => {
    carregar3d().catch(() => { modulo3d = null; });
    const pasta = new URL('.', new URL(cfg.modulo3d, window.location.href));
    FORMAS.forEach((f) => { new Image().src = new URL(`almofada-forma-${f}.png`, pasta).href; });
  };
  if (window.requestIdleCallback) requestIdleCallback(preCarregar, { timeout: 2500 });
  else setTimeout(preCarregar, 1200);

  /* ---------- estrutura ---------- */
  const inputFicheiro = h('input', {
    type: 'file', accept: 'image/jpeg,image/png,image/heic,image/heif,.heic,.heif,.jpg,.jpeg,.png',
    class: 'th-alm__ficheiro', tabindex: '-1', 'aria-hidden': 'true',
  });
  const palco = h('div', { class: 'th-alm__palco', 'aria-live': 'polite' });
  const titulo = h('h2', { class: 'th-alm__titulo' }, T.titulo);
  const subtitulo = h('p', { class: 'th-alm__subtitulo' }, T.subtitulo);
  const preco = h('p', { class: 'th-alm__preco' });
  const notaDesconto = h('p', { class: 'th-alm__nota-desconto', hidden: true });
  const lista = h('div', { class: 'th-foto__lugares', role: 'list' });
  const btnMais = h('button', { type: 'button', class: 'th-alm__secundario th-alm__mais' }, T.adicionarAlmofada);
  const seloMais = h('span', { class: 'th-alm__selo' });
  // bundle numa só linha (como no design): um cartão por almofada e um tracejado para juntar mais; por baixo, as opções da escolhida
  const notaLista = h('span', { class: 'th-foto__lugares-nota' });
  const opcoesAtiva = h('div', { class: 'th-alm__opcoes-ativa' });
  const blocoLista = h('div', { class: 'th-alm__bloco' },
    h('div', { class: 'th-foto__lugares-cab' }, h('p', { class: 'th-alm__rotulo' }, T.suasAlmofadas), notaLista),
    lista, opcoesAtiva);
  const btnMudar = h('button', { type: 'button', class: 'th-alm__secundario', disabled: true },
    icone('trocar'), h('span', {}, T.mudarImagem));
  const btnAdicionar = h('button', { type: 'button', class: 'th-alm__cta', disabled: true }, T.semImagem);
  const raizLoja = window.Shopify?.routes?.root || '/';
  const botoesAdicionar = [btnAdicionar];
  // depois de adicionar: convite para criar outra almofada (descontos automáticos na loja)
  const btnOutra = h('button', { type: 'button', class: 'th-alm__secundario th-alm__outra-botao' }, icone('foto'), h('span', {}, T.criarOutra));
  const selo = h('span', { class: 'th-alm__selo' }, T.descontoOutra);
  const blocoOutra = h('div', { class: 'th-alm__outra', hidden: true }, selo, btnOutra,
    h('a', { class: 'th-alm__ver-carrinho', href: `${raizLoja}cart` }, T.verCarrinho));
  const erroCarrinho = h('p', { class: 'th-alm__erro-carrinho', role: 'alert', hidden: true });
  const prazo = cfg.diasProducao > 0
    ? h('p', { class: 'th-alm__prazo' }, icone('camiao'),
      h('span', {}, formatar(T.prazo, { dias: cfg.diasProducao }), ' · ',
        h('a', { href: `${raizLoja}policies/shipping-policy`, target: '_blank', rel: 'noopener' }, T.prazoLink)))
    : null;
  const privacidade = h('p', { class: 'th-alm__prazo th-alm__privacidade' }, icone('escudo'),
    h('span', {}, T.privacidade, ' ',
      h('a', { href: `${raizLoja}policies/privacy-policy`, target: '_blank', rel: 'noopener' }, T.privacidadeLink)));
  const aviso = h('p', { class: 'th-alm__aviso' }, T.aviso, h('br'), T.personalizado);

  const painel = h('div', { class: 'th-alm__painel' },
    preco, notaDesconto, blocoLista, btnAdicionar, blocoOutra, prazo, privacidade, erroCarrinho, aviso);

  raiz.replaceChildren(h('div', { class: 'th-alm__cabecalho' }, titulo, subtitulo),
    h('div', { class: 'th-alm' }, palco, painel), inputFicheiro);

  /* ---------- preço e descontos ---------- */
  // descontos automáticos na loja, em todas as almofadas do carrinho: 2 = -10% · 3 = -15% · 4 ou mais = -25%
  const descontoPara = (n) => (n >= 4 ? 25 : n === 3 ? 15 : n === 2 ? 10 : 0);
  // o total escreve-se com o mesmo formato do preço da loja (€49,99 / 49,99 € …)
  function dinheiro(cent) {
    const modelo = cfg.tamanhos.find((t) => t.preco)?.preco || '€0,00';
    const virgula = /\d,\d{2}(?!\d)/.test(modelo);
    const [int, dec] = (cent / 100).toFixed(2).split('.');
    const milhares = int.replace(/\B(?=(\d{3})+(?!\d))/g, virgula ? '.' : ',');
    return modelo.replace(/\d[\d.,\s]*\d|\d/, `${milhares}${virgula ? ',' : '.'}${dec}`);
  }
  const precoDe = (t) => t.precoCent || Math.round(parseFloat(String(t.preco || '0').replace(/[^\d,.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.')) * 100) || 0;

  /* ---------- lista de almofadas (acordeão: a aberta mostra tamanho e foto; as outras, um resumo) ---------- */
  function resumo(a) {
    if (a.fase === 'a-gerar') return `${a.tamanho.cm} cm · ${T.aPrepararCurto}`;
    if (a.fase === 'erro') return `${a.tamanho.cm} cm · ${T.comErro}`;
    if (a.fase === 'vazio') return `${a.tamanho.cm} cm · ${T.semFotoAinda}`;
    return a.medidas ? `${a.tamanho.cm} cm · ${a.medidas.larguraCm} × ${a.medidas.alturaCm} cm` : `${a.tamanho.cm} cm`;
  }
  function miniatura(a) {
    const mini = h('span', { class: 'th-alm__mini' });
    const url = a.resultado?.preview || a.resultado?.recorte_url;
    if (url) mini.append(h('img', { src: url, alt: '' }));
    else if (a.fase === 'a-gerar') mini.append(h('span', { class: 'th-alm__mini-espera' }));
    else mini.append(icone('foto'));
    return mini;
  }
  function desenharLista() {
    const n = estado.almofadas.length, a = atual();
    // quanto se poupa com k almofadas (os descontos da loja), copiando o tamanho da que se está a ver
    const somaCom = (k) => estado.almofadas.slice(0, k).reduce((t, x) => t + precoDe(x.tamanho), 0) + Math.max(0, k - n) * precoDe(a.tamanho);
    const poupaCom = (k) => Math.round(somaCom(k) * descontoPara(k + (estado.almofadasNoCarrinho || 0)) / 100);
    notaLista.textContent = poupaCom(n) > 0 ? formatar(T.poupasValor, { v: dinheiro(poupaCom(n)) }) : T.umaPorFoto;
    const cartoes = estado.almofadas.map((x, i) => {
      const nome = formatar(T.almofadaN, { n: i + 1 });
      const curto = x.fase === 'a-gerar' ? T.aPrepararCurto : x.fase === 'erro' ? T.comErro : x.fase === 'vazio' ? `${x.tamanho.cm} cm · ${T.semFotoCurta}` : `${x.tamanho.cm} cm`;
      const mini = miniatura(x); mini.className = 'th-foto__lugar-mini' + (x.resultado ? '' : ' is-vazia');
      const bt = h('button', { type: 'button', class: 'th-foto__lugar-bt' + (i === estado.ativa ? ' is-ativo' : ''), 'aria-pressed': String(i === estado.ativa), 'aria-label': `${nome} · ${resumo(x)}`, onclick: () => ativar(i) },
        mini, h('span', { class: 'th-foto__lugar-texto' }, curto));
      const w = h('div', { class: 'th-foto__lugar', role: 'listitem' }, bt);
      if (n > 1) w.append(h('button', { type: 'button', class: 'th-foto__lugar-tirar', 'aria-label': `${T.remover} ${nome}`, onclick: (ev) => { ev.stopPropagation(); remover(i); } }, '×'));
      return w;
    });
    // só o próximo lugar tracejado (ao juntar uma, aparece a seguinte): diz quanto se poupa com ela
    if (!estado.adicionado) {
      for (let k = 0; n + k < 10 && k === 0; k++) {
        const extra = poupaCom(n + 1) - poupaCom(n);
        const bt = h('button', { type: 'button', class: 'th-foto__lugar-mais', onclick: () => juntar(k + 1) });
        bt.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
        bt.append(h('strong', {}, formatar(T.almofadaN, { n: n + k + 1 })));
        if (k === 0) bt.append(h('small', {}, extra > 0 ? formatar(poupaCom(n) > 0 ? T.poupaMais : T.poupaUm, { v: dinheiro(extra) }) : `+${dinheiro(precoDe(a.tamanho))}`));
        cartoes.push(bt);
      }
    }
    lista.replaceChildren(...cartoes);
    // as opções da almofada escolhida: tamanho e foto, cada uma numa linha
    const linha = (rotulo, ...conteudo) => h('div', { class: 'th-foto__linha' }, h('p', { class: 'th-alm__rotulo' }, rotulo), ...conteudo);
    const linhas = [];
    if (cfg.tamanhos.length > 1) {
      linhas.push(linha(T.rotTamanho, h('div', { class: 'th-foto__linha-botoes', role: 'radiogroup', 'aria-label': T.tamanhoTitulo },
        ...cfg.tamanhos.map((t) => h('button', {
          type: 'button', role: 'radio', 'aria-checked': String(t === a.tamanho),
          class: 'th-alm__pilula' + (t === a.tamanho ? ' is-ativo' : ''),
          'aria-label': `${t.etiqueta} · ${t.cm} cm`, disabled: !t.disponivel,
          onclick: () => escolherTamanho(t),
        }, `${t.cm} cm`))),
      h('p', { class: 'th-alm__item-nota' }, [a.tamanho.etiqueta, a.medidas && formatar(T.medidas, { largura: a.medidas.larguraCm, altura: a.medidas.alturaCm })].filter(Boolean).join(' · '))));
    }
    // o nome do ficheiro corta com "…" e nunca empurra o botão; sem foto, o botão diz "Adicionar foto"
    const ficheiro = h('span', { class: 'th-alm__item-ficheiro' }, a.nomeFicheiro || T.semFotoAinda); ficheiro.title = ficheiro.textContent;
    linhas.push(linha(T.rotFoto, h('div', { class: 'th-alm__item-foto' }, ficheiro,
      h('button', { type: 'button', class: 'th-alm__pilula', onclick: abrirSeletor }, a.fase === 'vazio' ? T.adicionarFoto : T.mudarFoto))));
    opcoesAtiva.replaceChildren(...linhas);
    atualizarBotao();
  }
  // juntar k almofadas: cópias da que se está a ver (mesma foto e tamanho), já prontas para o carrinho;
  // para outra foto, usa-se "Mudar foto". Se a de origem ainda não tem foto, abre logo a escolha da foto
  function juntar(k) {
    if (estado.ocupado) return;
    const de = atual();
    for (let j = 0; j < k; j++) {
      const nova = novaAlmofada(de.tamanho);
      if (de.fase === 'pronta') Object.assign(nova, { fase: 'pronta', resultado: de.resultado, nomeFicheiro: de.nomeFicheiro, medidas: de.medidas });
      estado.almofadas.push(nova);
    }
    estado.ativa = estado.almofadas.length - 1;
    estado.adicionado = false;
    desenharLista();
    mostrarAtiva();
    if (atual().fase !== 'pronta') abrirSeletor();
  }

  function ativar(i) {
    if (i === estado.ativa || estado.ocupado) return;
    estado.ativa = i;
    desenharLista();
    mostrarAtiva();
  }
  function remover(i) {
    if (estado.ocupado) return;
    const [a] = estado.almofadas.splice(i, 1);
    a.pedido?.abort();
    if (estado.ativa >= i && estado.ativa > 0) estado.ativa -= 1;
    estado.adicionado = estado.almofadas.length > 0 && !pendentes().length;
    desenharLista();
    mostrarAtiva();
  }
  btnMais.addEventListener('click', () => juntar(1));

  function escolherTamanho(t) {
    if (estado.ocupado) return;
    const a = atual();
    a.tamanho = t;
    alterada(a); // outro tamanho = esta volta a poder ser adicionada
    if (estado.visor && estado.fase === 'preview') a.medidas = estado.visor.setTamanho(t.cm);
    if (estado.fase === 'vazio') estado.visorVazio?.setTamanho(t.cm);
    desenharLista();
  }

  function atualizarBotao() {
    const a = atual(), todas = estado.almofadas, porAdicionar = pendentes(), lista = porAdicionar.length ? porAdicionar : todas;
    // com a almofada à vista, o subtítulo já não é preciso (poupa altura no telemóvel)
    subtitulo.hidden = todas.some((x) => x.fase !== 'vazio');
    const disponivel = lista.every((x) => x.tamanho.disponivel !== false);
    const prontas = lista.every((x) => x.fase === 'pronta');
    const aPreparar = lista.some((x) => x.fase === 'a-gerar');
    const falta = lista.find((x) => x.fase === 'vazio' || x.fase === 'erro');
    // preço: soma das almofadas, com o desconto que a loja aplica no carrinho
    // as que já estão no carrinho contam para o desconto (e não se contam duas vezes)
    const n = (porAdicionar.length || (estado.adicionado ? 0 : todas.length)) + (estado.almofadasNoCarrinho || 0);
    const pct = descontoPara(n), soma = lista.reduce((t, x) => t + precoDe(x.tamanho), 0), total = Math.round(soma * (1 - pct / 100));
    preco.replaceChildren(...(pct ? [h('s', { class: 'th-alm__preco-antes' }, dinheiro(soma)), ' ', dinheiro(total)] : [dinheiro(soma)]));
    preco.hidden = !soma;
    notaDesconto.textContent = formatar(T.poupas, { pct });
    notaDesconto.hidden = !pct;
    for (const b of botoesAdicionar) {
      if (estado.ocupado) { b.disabled = true; b.textContent = T.aAdicionar; continue; }
      b.disabled = !prontas || !disponivel || estado.adicionado;
      b.textContent = !disponivel ? T.esgotado : estado.adicionado ? T.adicionado
        : prontas ? (lista.length > 1 ? formatar(T.adicionarTotal, { total: dinheiro(total) }) : T.adicionar)
          : aPreparar ? (lista.length > 1 ? T.aindaAPreparar : T.semImagem)
            : lista.length > 1 && falta ? formatar(T.faltaFoto, { nome: nomeDe(falta) }) : T.semImagem;
      b.classList.toggle('is-adicionado', !!estado.adicionado);
    }
    blocoOutra.hidden = !estado.adicionado;
    const nc = estado.almofadasNoCarrinho || 1;
    selo.textContent = nc === 1 ? T.descontoOutra : nc === 2 ? T.desconto3 : T.desconto4;
    selo.hidden = nc >= 4;
    // convite para juntar mais uma (o desconto sobe com cada almofada)
    seloMais.textContent = n <= 1 ? T.descontoOutra : n === 2 ? T.desconto3 : T.desconto4;
    seloMais.hidden = n >= 4;
    btnMais.hidden = estado.adicionado || todas.length >= 10;
    btnMudar.disabled = a.fase === 'vazio';
  }

  /* ---------- palco: mostra a almofada aberta na lista ---------- */
  function mostrarAtiva() {
    const a = atual();
    estado.vista += 1;
    estado.pararAnimacao?.();
    erroCarrinho.hidden = true;
    if (a.fase === 'pronta') fasePreview(a);
    else if (a.fase === 'a-gerar') faseAGerar(a);
    else if (a.fase === 'erro') faseErro(a.erro);
    else faseVazio();
  }

  function faseVazio() {
    estado.fase = 'vazio';
    destruirVisor();
    // sem foto: a almofada 3D verdadeira (a forma de cão da animação de espera), branca, com o símbolo de foto
    const caixa = h('div', { class: 'th-alm__vazio-3d' });
    const zona = h('div', { class: 'th-alm__zona th-alm__zona-3d', role: 'button', tabindex: '0' },
      caixa,
      h('span', { class: 'th-alm__cta th-alm__cta--pequeno' }, T.uploadBotao),
      h('p', { class: 'th-alm__zona-ajuda' }, T.uploadArrastar),
      h('p', { class: 'th-alm__zona-ajuda th-alm__zona-formatos' }, T.uploadAjuda));
    // arrastar a almofada 3D (para a rodar) não abre a escolha da foto; só um toque
    let toque = null;
    zona.addEventListener('pointerdown', (e) => { toque = [e.clientX, e.clientY]; });
    zona.addEventListener('click', (e) => { if (toque && Math.hypot(e.clientX - toque[0], e.clientY - toque[1]) > 6) return; abrirSeletor(); });
    zona.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrirSeletor(); } });
    zona.addEventListener('pointerenter', carregar3d, { once: true });
    zona.addEventListener('dragover', (e) => { e.preventDefault(); zona.classList.add('is-arrastar'); });
    zona.addEventListener('dragleave', () => zona.classList.remove('is-arrastar'));
    zona.addEventListener('drop', (e) => {
      e.preventDefault();
      zona.classList.remove('is-arrastar');
      const f = e.dataTransfer?.files?.[0];
      if (f) receberFicheiro(f);
    });
    palco.replaceChildren(zona, h('p', { class: 'th-alm__dica' }, T.dica));
    almofadaVazia(caixa);
    atualizarBotao();
  }
  async function almofadaVazia(caixa) {
    try {
      const { Almofada3D } = await carregar3d();
      if (!caixa.isConnected || estado.fase !== 'vazio') return;
      const pasta = new URL('.', new URL(cfg.modulo3d, window.location.href));
      const forma = await new Promise((ok, falha) => { const im = new Image(); im.crossOrigin = 'anonymous'; im.onload = () => ok(im); im.onerror = falha; im.src = new URL('almofada-forma-cao.png', pasta).href; });
      if (!caixa.isConnected || estado.fase !== 'vazio') return;
      // a forma em grande, branca, com o símbolo de foto ao centro
      const W = 1200, H = Math.round(W * forma.height / forma.width), c = document.createElement('canvas'); c.width = W; c.height = H;
      const g = c.getContext('2d'); g.drawImage(forma, 0, 0, W, H);
      g.globalCompositeOperation = 'source-atop'; g.fillStyle = '#ffffff'; g.fillRect(0, 0, W, H);
      const L = W * 0.38, cx = W * 0.5, cy = H * 0.55, k = L / 600;
      g.fillStyle = '#f6efe9'; g.beginPath(); g.arc(cx, cy, L / 2, 0, Math.PI * 2); g.fill();
      g.strokeStyle = '#7a1f0e'; g.lineWidth = 34 * k; g.lineJoin = 'round'; g.lineCap = 'round';
      g.beginPath(); g.roundRect(cx - 170 * k, cy - 140 * k, 340 * k, 280 * k, 46 * k); g.stroke();
      g.beginPath(); g.arc(cx - 75 * k, cy - 50 * k, 34 * k, 0, Math.PI * 2); g.stroke();
      g.beginPath(); g.moveTo(cx - 155 * k, cy + 100 * k); g.lineTo(cx - 30 * k, cy); g.lineTo(cx + 60 * k, cy + 70 * k); g.lineTo(cx + 100 * k, cy + 35 * k); g.lineTo(cx + 160 * k, cy + 90 * k); g.stroke();
      const vis = new Almofada3D(caixa, { margemCm: cfg.margemCm, regua: false });
      estado.visorVazio = vis;
      await vis.setImagem(c.toDataURL('image/png'), atual().tamanho.cm);
    } catch (e) { console.warn('[almofada] sem almofada 3D vazia', e); }
  }

  function faseAGerar(a) {
    estado.fase = 'a-gerar';
    destruirVisor();
    // almofadas brancas em 3D a rodar enquanto se prepara o recorte;
    // o mesmo visor mostra depois a almofada do cliente, no mesmo sítio
    const tela = h('div', { class: 'th-alm__tela' });
    estado.tela = tela;
    const mensagens = T.aGerarMensagens.split('|').map((s) => s.trim()).filter(Boolean);
    const msg = h('p', { class: 'th-alm__gerar-msg' }, mensagens[0] || '');
    const barra = h('div', { class: 'th-alm__barra-progresso' });
    palco.replaceChildren(tela, h('div', { class: 'th-alm__gerar' },
      h('p', { class: 'th-alm__gerar-titulo' }, T.aGerarTitulo),
      msg,
      h('div', { class: 'th-alm__barra', role: 'progressbar', 'aria-label': T.aGerarTitulo }, barra),
      h('p', { class: 'th-alm__zona-ajuda' }, T.aGerarAjuda)));

    carregar3d().then(({ Almofada3D }) => {
      if (estado.fase !== 'a-gerar' || estado.tela !== tela) return;
      estado.visor = new Almofada3D(tela, { margemCm: cfg.margemCm });
      const pasta = new URL('.', new URL(cfg.modulo3d, window.location.href));
      estado.visor.modoEspera(FORMAS.map((f) => new URL(`almofada-forma-${f}.png`, pasta).href));
    }).catch((e) => console.warn('[almofada] sem animação 3D', e));

    // a barra conta desde que esta almofada começou a ser preparada (ao voltar a ela, continua onde ia)
    const inicio = a.inicio || performance.now();
    let i = -1;
    const passo = () => {
      const s = (performance.now() - inicio) / 1000;
      // avança depressa no início e abranda até ~92 %
      barra.style.width = `${Math.min(92, 100 * (1 - Math.exp(-s / 11)))}%`;
      const novo = Math.min(Math.floor(s / 3.2), mensagens.length - 1);
      if (novo !== i) { i = novo; msg.textContent = mensagens[i]; }
    };
    passo();
    const temporizador = setInterval(passo, 200);
    estado.pararAnimacao = () => clearInterval(temporizador);
    atualizarBotao();
  }

  async function fasePreview(a) {
    const vista = estado.vista;
    estado.pararAnimacao?.();
    const { Almofada3D } = await carregar3d();
    if (vista !== estado.vista) return;
    // reaproveita o visor (da animação de espera ou da almofada anterior): a almofada aparece no mesmo sítio
    let tela = estado.visor && estado.tela;
    if (!tela) {
      destruirVisor();
      tela = h('div', { class: 'th-alm__tela' });
      estado.tela = tela;
      estado.visor = new Almofada3D(tela, { margemCm: cfg.margemCm });
    }
    palco.replaceChildren(
      tela,
      h('div', { class: 'th-alm__barra-ferramentas' },
        h('p', { class: 'th-alm__arrastar' }, icone('rodar'), T.arrastar),
        h('div', { class: 'th-alm__botoes-palco' }, btnMudar)));

    let m;
    try { m = await estado.visor.setImagem(a.resultado.preview || a.resultado.recorte_url, a.tamanho.cm); }
    catch (e) { console.error('[almofada]', e); if (vista === estado.vista) faseErro(T.erroGeral); return; }
    if (vista !== estado.vista || m === null || estado.ocupado) return; // outro pedido ganhou (ou está a adicionar)
    // o tamanho pode ter mudado enquanto a imagem carregava
    if (a.tamanho.cm !== estado.visor.ladoCm) m = estado.visor.setTamanho(a.tamanho.cm);
    estado.fase = 'preview';
    a.medidas = m;
    desenharLista();
  }

  function faseErro(mensagem) {
    estado.pararAnimacao?.();
    estado.fase = 'erro';
    destruirVisor();
    palco.replaceChildren(h('div', { class: 'th-alm__erro', role: 'alert' },
      h('p', {}, mensagem),
      h('button', { type: 'button', class: 'th-alm__cta th-alm__cta--pequeno', onclick: abrirSeletor }, T.tentarNovamente)));
    atualizarBotao();
  }

  function destruirVisor() {
    estado.visorVazio?.dispose(); estado.visorVazio = null;
    estado.visor?.dispose();
    estado.visor = null;
    estado.tela = null;
  }

  /* ---------- upload ---------- */
  function abrirSeletor() {
    if (estado.ocupado) return;
    inputFicheiro.value = '';
    inputFicheiro.click();
  }

  inputFicheiro.addEventListener('change', () => {
    const f = inputFicheiro.files?.[0];
    if (f) receberFicheiro(f);
  });

  // a foto vai para a almofada aberta; cada almofada prepara-se sozinha (dá para abrir outra enquanto espera)
  async function receberFicheiro(ficheiro) {
    const a = atual();
    const tipoOk = /^image\//.test(ficheiro.type) || /\.(heic|heif|jpe?g|png)$/i.test(ficheiro.name);
    if (estado.ocupado) return;
    alterada(a);
    a.pedido?.abort();
    a.resultado = null; a.medidas = null; a.nomeFicheiro = ficheiro.name || '';
    const falhar = (mensagem) => { a.fase = 'erro'; a.erro = mensagem; desenharLista(); if (a === atual()) mostrarAtiva(); };
    if (!tipoOk) return falhar(T.erroTipo);
    if (ficheiro.size > cfg.maxMb * 1024 * 1024) return falhar(formatar(T.erroTamanho, { mb: cfg.maxMb }));

    const pedido = new AbortController();
    a.pedido = pedido;
    a.fase = 'a-gerar';
    a.inicio = performance.now();
    desenharLista();
    if (a === atual()) mostrarAtiva();
    carregar3d();

    try {
      let resultado;
      if (cfg.processarLocalmente) {
        resultado = await cfg.processarLocalmente(ficheiro);
      } else {
        const dados = new FormData();
        dados.append('imagem', ficheiro, ficheiro.name || 'foto.jpg');
        const r = await fetch(`${cfg.servidor.replace(/\/$/, '')}/remove-bg`, {
          method: 'POST', body: dados, signal: pedido.signal,
        });
        const corpo = await r.json().catch(() => ({}));
        if (!r.ok) {
          const chave = ERROS_SERVIDOR[corpo.codigo] || 'erroGeral';
          throw Object.assign(new Error(formatar(T[chave], { mb: cfg.maxMb })), { mostrar: true });
        }
        resultado = corpo;
      }
      if (pedido.signal.aborted || !estado.almofadas.includes(a)) return;
      a.resultado = resultado;
      a.fase = 'pronta';
      a.pedido = null;
      desenharLista();
      if (a === atual()) mostrarAtiva();
    } catch (e) {
      if (e.name === 'AbortError') return;
      console.error('[almofada]', e);
      falhar(e.mostrar ? e.message : T.erroGeral);
    }
  }

  btnMudar.addEventListener('click', abrirSeletor);

  /* ---------- carrinho ---------- */
  async function adicionar() {
    // só as que ainda não estão no carrinho (lista fixa: a lista fica bloqueada enquanto adiciona)
    const lista = pendentes();
    if (estado.ocupado || !lista.length || !lista.every((a) => a.fase === 'pronta')) return;
    estado.ocupado = true;
    try { await adicionarLista(lista); } finally { estado.ocupado = false; atualizarBotao(); }
  }
  async function adicionarLista(lista) {
    const itens = lista.map((a) => {
      const propriedades = {
        _imagem_original: a.resultado.original_url,
        _recorte: a.resultado.recorte_url,
        _tamanho_cm: String(a.tamanho.cm),
      };
      if (a.medidas) propriedades._medidas = `${a.medidas.larguraCm} × ${a.medidas.alturaCm} cm`;
      return { id: a.tamanho.varianteId, quantity: 1, properties: propriedades };
    });

    const marcar = () => { lista.forEach((a) => { a.noCarrinho = true; }); estado.adicionado = !pendentes().length; };
    if (cfg.modoTeste) {
      for (const item of itens) cfg.aoAdicionarTeste?.(item);
      estado.almofadasNoCarrinho = (estado.almofadasNoCarrinho || 0) + itens.length;
      marcar();
      atualizarBotao();
      return;
    }

    for (const b of botoesAdicionar) { b.disabled = true; b.textContent = T.aAdicionar; }
    erroCarrinho.hidden = true;
    // imagem de cada almofada 3D para o carrinho (se falhar, o carrinho mostra a foto do produto):
    // o visor mostra cada uma por um instante e volta à que estava aberta
    try {
      const visor = estado.visor;
      if (visor) {
        for (const [i, a] of lista.entries()) {
          try {
            const m = await visor.setImagem(a.resultado.preview || a.resultado.recorte_url, a.tamanho.cm);
            if (m === null) continue; // não devia acontecer (a lista está bloqueada); sem imagem desta
            a.medidas = m;
            if (a.medidas) itens[i].properties._medidas = `${a.medidas.larguraCm} × ${a.medidas.alturaCm} cm`;
            const blob = await visor.capturaBlob();
            if (!blob) continue;
            const dados = new FormData();
            dados.append('recorte_url', a.resultado.recorte_url);
            dados.append('imagem', blob, 'almofada.png');
            const r = await fetch(`${cfg.servidor.replace(/\/$/, '')}/preview-carrinho`, { method: 'POST', body: dados });
            if (r.ok) itens[i].properties._preview = (await r.json()).preview_url;
          } catch (e) { console.warn('[almofada] sem imagem para o carrinho', e); }
        }
        if (estado.visor === visor && atual().resultado) {
          const m = await visor.setImagem(atual().resultado.preview || atual().resultado.recorte_url, atual().tamanho.cm);
          if (m) { atual().medidas = m; estado.fase = 'preview'; }
        }
      }
    } catch (e) { console.warn('[almofada] sem imagem para o carrinho', e); }
    const gaveta = cfg.depoisDeAdicionar !== 'carrinho' ? document.querySelector('cart-drawer') : null;
    try {
      const corpo = { items: itens };
      if (gaveta?.renderContents) {
        corpo.sections = gaveta.getSectionsToRender().map((s) => s.id);
        corpo.sections_url = window.location.pathname;
      }
      const r = await fetch(`${raizLoja}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corpo),
      });
      const resposta = await r.json();
      if (!r.ok) throw new Error(resposta.description || resposta.message || T.erroCarrinho);
      // já estão no carrinho: marca-se logo (um erro a atualizar a gaveta não pode deixar adicionar outra vez)
      marcar();

      if (cfg.depoisDeAdicionar === 'carrinho' || (cfg.depoisDeAdicionar === 'gaveta' && !gaveta?.renderContents)) {
        window.location.href = `${raizLoja}cart`;
        return;
      }
      if (cfg.depoisDeAdicionar === 'gaveta' && gaveta?.renderContents) {
        try {
          gaveta.classList.remove('is-empty');
          gaveta.renderContents({ ...resposta, id: resposta.items?.[0]?.id ?? itens[0].id });
        } catch (e) { console.warn('[almofada] não foi possível abrir a gaveta', e); }
      } else if (gaveta?.getSectionsToRender && resposta.sections) {
        // fica na página: atualiza o ícone do carrinho e a gaveta sem a abrir
        try {
          gaveta.classList.remove('is-empty');
          for (const s of gaveta.getSectionsToRender()) {
            // igual ao renderContents do tema (Dawn): o seletor indica o elemento a substituir
            const alvo = s.selector ? document.querySelector(s.selector) : document.getElementById(s.section || s.id);
            const html = resposta.sections[s.id];
            if (!alvo || !html) continue;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fonte = doc.querySelector(s.selector || '.shopify-section') || doc.body;
            alvo.innerHTML = fonte.innerHTML;
          }
        } catch (e) { console.warn('[almofada] não foi possível atualizar o carrinho', e); }
      }
      document.dispatchEvent(new CustomEvent('th:almofada:adicionada', { detail: resposta }));
      await contarNoCarrinho();
      atualizarBotao();
    } catch (e) {
      erroCarrinho.textContent = e.message || T.erroCarrinho;
      erroCarrinho.hidden = false;
      atualizarBotao();
    }
  }
  for (const b of botoesAdicionar) b.addEventListener('click', adicionar);

  // almofadas que já estão no carrinho (contam para o desconto)
  async function contarNoCarrinho() {
    if (cfg.modoTeste) return;
    try {
      const carrinho = await fetch(`${raizLoja}cart.js`).then((x) => x.json());
      estado.almofadasNoCarrinho = carrinho.items
        .filter((i) => i.properties?._recorte).reduce((t, i) => t + i.quantity, 0);
    } catch { /* sem carrinho: conta só as desta página */ }
  }

  btnOutra.addEventListener('click', () => {
    // começa uma lista nova (as anteriores já estão no carrinho)
    estado.adicionado = false;
    estado.almofadas = [novaAlmofada(atual().tamanho)];
    estado.ativa = 0;
    desenharLista();
    mostrarAtiva();
    raiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
    abrirSeletor();
  });

  desenharLista();
  faseVazio();
  contarNoCarrinho().then(atualizarBotao);

  const api = {
    destruir() { estado.almofadas.forEach((a) => a.pedido?.abort()); estado.pararAnimacao?.(); destruirVisor(); raiz._thAlmofada = null; },
    estado,
  };
  raiz._thAlmofada = api;
  return api;
}

export function iniciarTodos(contexto = document) {
  contexto.querySelectorAll('[data-th-almofada]').forEach((raiz) => {
    const json = raiz.querySelector('script[type="application/json"]');
    if (!json) return;
    try {
      iniciar(raiz, JSON.parse(json.textContent));
    } catch (e) {
      console.error('[almofada] configuração inválida', e);
    }
  });
}

if (!window.__thAlmofadaManual) {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => iniciarTodos());
  else iniciarTodos();
  // editor de temas: volta a iniciar quando a secção é alterada
  document.addEventListener('shopify:section:load', (e) => iniciarTodos(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-th-almofada]').forEach((r) => r._thAlmofada?.destruir());
  });
}
